<template>
  <div class="item-card">
    <div class="card-title">创意基础设置</div>
    <div class="card-content">
      <ul class="modal-form">
        <el-form :model="formData" :rules="rules" ref="creativeBasesetRef">
          <li class="form-item">
            <span class="form-label">创意方式：</span>
            <div class="form-value">
              <el-radio-group v-model="formData.creative_material_mode">
                <el-radio label="STATIC_ASSEMBLE">程序化创意</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item" v-show="showCard">
            <span class="form-label" style="padding-top: 12px">推广卡片：</span>
            <div class="form-value">
              <el-form-item prop="promotion_card">
                <el-radio-group v-model="formData.promotion_card" @change="changePromotionCard">
                  <el-radio :disabled="onlyCard" label="0">不启用</el-radio>
                  <el-radio label="1">启用</el-radio>
                </el-radio-group>
              </el-form-item>
              <div style="margin: 10px 0px">
                <el-radio-group v-show="formData.promotion_card === '1'" v-model="formData.cardType" size="mini" @change="checkRule">
                  <el-radio-button :label="0">素材库选择</el-radio-button>
                  <el-radio-button :label="1">手动创建</el-radio-button>
                </el-radio-group>
              </div>
              <!-- 素材库选择 -->
              <div class="material-select" v-show="formData.promotion_card === '1' && formData.cardType === 0">
                <table border="1px solid red" class="checkTable" cellpadding="10px">
                  <tr class="header-tr">
                    <th>广告账户</th>
                    <th>基础创意组件</th>
                  </tr>
                  <tr v-for="item of accountList" :key="item.account.advertiserId">
                    <th class="count-wrap">
                      <div>{{ item.account.advertiserName }}</div>
                      <div class="count-id">ID:{{ item.account.advertiserId }}</div>
                    </th>
                    <th>
                      <div class="value-wrap" v-if="item.cardData">
                        <span class="com-name">{{ item.cardData.component_name }}</span>
                        <span class="com-btn" @click="checkCard(item.account)">替换</span>
                      </div>
                      <el-button v-else @click="checkCard(item.account)">点击选择</el-button>
                    </th>
                  </tr>
                </table>
              </div>
              <!-- 手动选择 -->
              <el-form :model="formData.promotion_card_data" :rules="cardRules" ref="cardRef">
                <div class="upload-wrap" v-show="formData.promotion_card === '1' && formData.cardType === 1">
                  <div class="upload-item">
                    <span class="upload-label require">卡片主图：</span>
                    <div class="upload-value">
                      <el-form-item prop="path" style="margin-bottom: 0px">
                        <div class="add-material" @click="showMaterialModal">
                          <div class="img-wrap" v-show="formData.promotion_card_data.path">
                            <img class="materialI-img" :src="formData.promotion_card_data.path || ''" alt="" />
                          </div>
                          <div class="add-wrap" v-show="!formData.promotion_card_data.path">
                            <i class="el-icon-plus add-icon"></i>
                            <span class="add-text">上传照片</span>
                          </div>
                        </div>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="upload-item">
                    <span class="upload-label require" style="padding-top: 6px">卡片标题：</span>
                    <div class="upload-value">
                      <el-form-item prop="product_description" style="margin-bottom: 0px">
                        <el-input
                          style="width: 224px"
                          placeholder="(必填)输入标题"
                          v-model="formData.promotion_card_data.product_description"
                        ></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="upload-item">
                    <span class="upload-label require">推广卖点：</span>
                    <div class="upload-value">
                      <el-form-item prop="product_selling_points_type" style="margin-bottom: 0px">
                        <el-radio-group v-model="formData.promotion_card_data.product_selling_points_type">
                          <el-radio :label="1">系统推荐卖点</el-radio>
                          <el-radio :label="2">自定义推广卖点</el-radio>
                        </el-radio-group>
                        <div class="md-wrap">
                          <div class="md-item" v-show="formData.promotion_card_data.product_selling_points_type === 1">
                            <el-select placeholder="请选择" v-model="selectedSysList" multiple collapse-tags>
                              <el-option v-for="(item, index) of allSysList" :key="index" :label="item" :value="item"> </el-option>
                            </el-select>
                          </div>
                          <div class="md-item" v-show="formData.promotion_card_data.product_selling_points_type === 2">
                            <!-- <el-form :model="selectedCusList"> -->
                            <div v-for="(item, key) of selectedCusList" :key="key">
                              <!-- :rules="{
                            required: true,
                            message: '请正确输入推广卖点，6-9个字',
                            trigger: 'blur',
                          }"
                          :prop="key + ''" -->
                              <div class="input-item">
                                <el-input
                                  v-model.trim="selectedCusList[key]"
                                  placeholder="输入自定义推广卖点"
                                  maxlength="9"
                                  show-word-limit
                                ></el-input>
                                <span class="add-btn" style="background-color: #1890ff" @click="addCustomItem(true, key)"
                                  ><i class="el-icon-plus"></i
                                ></span>
                                <span
                                  v-show="Object.entries(selectedCusList).length > 1"
                                  class="add-btn"
                                  style="background-color: #ed4014"
                                  @click="addCustomItem(false, key)"
                                  ><i class="el-icon-minus"></i
                                ></span>
                              </div>
                            </div>
                            <!-- </el-form> -->
                          </div>
                        </div>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="upload-item">
                    <span class="upload-label require">行动号召：</span>
                    <div class="upload-value">
                      <el-radio-group v-model="formData.promotion_card_data.enable_personal_action">
                        <el-radio :label="true">开启智能优选</el-radio>
                        <el-radio :label="false">关闭智能优选</el-radio>
                      </el-radio-group>
                      <el-form-item prop="call_to_action" style="margin-bottom: 0px">
                        <el-select placeholder="请选择" style="margin-top: 12px" v-model="formData.promotion_card_data.call_to_action">
                          <el-option v-for="(item, index) of call_to_actionList" :key="index" :label="item" :value="item"> </el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="upload-item">
                    <span class="upload-label require" style="padding-top: 6px">组件名称：</span>
                    <div class="upload-value">
                      <el-form-item prop="component_name" style="margin-bottom: 0px">
                        <el-input
                          style="width: 224px"
                          placeholder="(必填)输入组件名称"
                          v-model="formData.promotion_card_data.component_name"
                        ></el-input>
                      </el-form-item>
                    </div>
                  </div>
                </div>
              </el-form>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label require" style="padding-top: 6px">应用名称：</span>
            <div class="form-value">
              <el-form-item prop="app_name" style="margin-bottom: 0px">
                <el-input
                  type="text"
                  placeholder="(必填)4-20个字符，中文占两个字符"
                  maxlength="10"
                  show-word-limit
                  style="width: 280px"
                  v-model="formData.app_name"
                ></el-input>
              </el-form-item>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label" style="padding-top: 6px">副标题：</span>
            <div class="form-value">
              <el-input
                type="text"
                placeholder="4-20个字符，中文占两个字符"
                maxlength="10"
                show-word-limit
                style="width: 280px"
                v-model="formData.sub_title"
              ></el-input>
            </div>
          </li>
          <li class="form-item" v-show="delivery_placement && delivery_placement.delivery_range === 'UNIVERSAL'">
            <span class="form-label">自动生成素材：</span>
            <div class="form-value">
              <el-radio-group v-model="formData.creative_auto_generate_switch">
                <el-radio :label="0">不启用</el-radio>
                <el-radio :label="1">启用</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item" v-show="!(delivery_placement && delivery_placement.delivery_range === 'UNIVERSAL')">
            <span class="form-label">自动生成视频素材：</span>
            <div class="form-value">
              <el-radio-group v-model="formData.is_presented_video">
                <el-radio :label="0">不启用</el-radio>
                <el-radio :label="1">启用</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item" v-show="delivery_placement && delivery_placement.delivery_range !== 'UNION'">
            <span class="form-label">广告评论：</span>
            <div class="form-value">
              <el-radio-group v-model="formData.is_comment_disable">
                <el-radio :label="1">关闭</el-radio>
                <el-radio :label="0">启用</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item" v-show="delivery_placement && delivery_placement.delivery_range !== 'UNION'">
            <span class="form-label">客户端下载视频：</span>
            <div class="form-value">
              <el-radio-group v-model="formData.ad_download_status">
                <el-radio :label="1">关闭</el-radio>
                <el-radio :label="0">启用</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label">创意展现：</span>
            <div class="form-value">
              <el-radio-group v-model="formData.creative_display_mode">
                <el-radio label="CREATIVE_DISPLAY_MODE_CTR">优选模式</el-radio>
                <el-radio label="CREATIVE_DISPLAY_MODE_RANDOM">轮播模式</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label">搭配试玩：</span>
            <div class="form-value">
              <el-radio-group v-model="formData.playableType" @change="changePlayableType">
                <el-radio label="OFF">不启用</el-radio>
                <el-radio label="ON">启用普通试玩</el-radio>
              </el-radio-group>
              <el-form-item prop="playable_url" style="margin-top: 8px" v-if="formData.playableType === 'ON'">
                <el-select v-model="formData.playable_url" filterable placeholder="请选择试玩素材">
                  <el-option v-for="item in playableList" :key="item.playable_id" :label="item.playable_name" :value="item.playable_url">
                    <span style="float: left">{{ item.playable_name }}</span>

                    <el-popover
                      placement="bottom"
                      width="200"
                      trigger="click"
                      content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                    >
                      <div class="iframe-wrap">
                        <iframe :src="item.playable_url" class="iframe-content" frameborder="0"></iframe>
                      </div>
                      <span slot="reference" @click.stop style="float: right; color: #338aff; font-size: 13px">预览</span>
                    </el-popover>
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </li>
        </el-form>
      </ul>
    </div>

    <!-- 素材选择弹框 -->
    <material-modal :singleSelect="true" ref="materialModalRef" selectType="image" @selectOk="selectedMaterial"></material-modal>

    <!-- 推广卡片选择弹框 -->
    <card-modal @cardSelectOk="cardSelectOk" ref="cardModalRef"></card-modal>
  </div>
</template>

<script>
import { getPromotion, getCallToAction, getPlayableList, getToutiaoId } from "@/api/promotion.js";
import { mapState } from "vuex";
import MaterialModal from "./sub/materialModal.vue";
import CardModal from "./sub/cardModal.vue";
export default {
  components: {
    MaterialModal,
    CardModal,
  },
  data() {
    return {
      formData: {
        creative_material_mode: "STATIC_ASSEMBLE",
        promotion_card: "0",
        cardType: 0, //0素材库选择 手动创建
        promotion_card_data: {
          product_image_id: "",
          product_description: "",
          product_selling_points_type: 1, //系统推荐卖点 1， 自定义推广卖点 2
          enable_personal_action: true,
          call_to_action: null,
          path: "", //图片路径
          component_name: "",
        },
        app_name: "",
        sub_title: "",
        creative_auto_generate_switch: 0,
        is_presented_video: 0,
        is_comment_disable: 0,
        ad_download_status: 1,
        creative_display_mode: "CREATIVE_DISPLAY_MODE_CTR",
        playableType: "OFF",
        playable_url: null,
      },
      allSysList: [],
      selectedSysList: [],
      selectedCusList: { [new Date().getTime()]: "" },
      call_to_actionList: [],
      onlyCard: false, //是否禁用不启用
      accountList: [], //推广卡片素材选择列表
      playableList: [], //试玩素材列表
      rules: {
        app_name: [
          {
            required: true,
            message: "请输入应用名称",
            trigger: ["blur", "change"],
          },
        ],
        playable_url: {
          required: true,
          message: "请选择试玩素材",
          trigger: ["blur", "change"],
        },
        promotion_card: {
          validator: (rule, value, callback) => {
            if (this.formData.promotion_card === "1" && this.formData.cardType === 0) {
              let nullData = this.accountList.find((item) => !item.cardData);
              if (nullData) {
                callback(new Error("请选择创意组件"));
              } else {
                callback();
              }
            } else {
              callback();
            }
          },
          trigger: "change",
        },
      },
      cardRules: {
        path: [
          {
            validator: (rule, value, callback) => {
              if (this.formData.promotion_card === "1" && this.formData.cardType === 1 && value === "") {
                callback(new Error("请选择卡片主图"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        product_description: [
          {
            validator: (rule, value, callback) => {
              if (this.formData.promotion_card === "1" && this.formData.cardType === 1 && value === "") {
                callback(new Error("请输入卡片标题"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        component_name: [
          {
            validator: (rule, value, callback) => {
              if (this.formData.promotion_card === "1" && this.formData.cardType === 1 && value === "") {
                callback(new Error("请输入组件名称"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        product_selling_points_type: [
          {
            validator: (rule, value, callback) => {
              if (this.formData.promotion_card === "1" && this.formData.cardType === 1) {
                if (value === 1 && this.selectedSysList.length === 0) {
                  callback(new Error("系统卖点不可为空"));
                } else if (value == 2) {
                  let flag = Object.values(this.selectedCusList).indexOf("");
                  flag > -1 ? callback(new Error("自定义卖点不可为空")) : callback();
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        call_to_action: [
          {
            validator: (rule, value, callback) => {
              if (this.formData.promotion_card === "1" && this.formData.cardType === 1 && value == null) {
                callback(new Error("行动号召不可为空"));
              } else {
                callback();
              }
            },
            trigger: ["change"],
          },
        ],
      },
      showCard: true,
    };
  },
  methods: {
    initOptions() {
      let advertiserIdList = this.adCount.map((item) => item.advertiserId).join();
      //推广卖点查询
      getPromotion({
        advertiserId: advertiserIdList,
      }).then((res) => {
        if (res.code === "0000") {
          this.allSysList = res.promotions;
        }
      });
      //行动号召查询
      getCallToAction({
        advertiserId: advertiserIdList,
      }).then((res) => {
        if (res.code === "0000") {
          this.call_to_actionList = res.callToActions;
        }
      });
      //查询试玩素材
      getPlayableList({
        advertiserId: this.adCount[0].advertiserId,
      }).then((res) => {
        if (res.code === "0000") {
          this.playableList = res.playableInfos;
        }
      });
      //加载store数据
      this.fillStoreData();
    },
    addCustomItem(isAdd, key) {
      if (isAdd) {
        this.$set(this.selectedCusList, new Date().getTime(), "");
      } else {
        this.$delete(this.selectedCusList, key);
      }
    },
    showMaterialModal() {
      this.$refs.materialModalRef.showModal();
    },
    selectedMaterial(resData) {
      let selectedData = resData.mapList;
      let selectObj = Object.values(selectedData)[0];
      if (selectObj.toutiaoId) {
        this.formData.promotion_card_data.product_image_id = selectObj.toutiaoId;
      } else {
        getToutiaoId({
          advertiserId: this.adCount[0].advertiserId,
          fileNames: selectObj.uuid,
        }).then((res) => {
          if (res.code === "0000") {
            let toutiaoItem = res.data[0];
            if (toutiaoItem.toutiaoId) {
              this.formData.promotion_card_data.product_image_id = toutiaoItem.toutiaoId;
            } else {
              this.$message.error("头条ID获取失败");
            }
          }
        });
      }

      this.formData.promotion_card_data.path = selectObj.path;
    },
    saveInStore() {
      let storeData = JSON.parse(JSON.stringify(this.formData));
      if (storeData.promotion_card === "1") {
        //启用推广卡片
        if (this.formData.cardType === 0) {
          //素材库选择
          let accountList = JSON.parse(JSON.stringify(this.accountList));
          storeData.promotion_card = {
            cardType: this.formData.cardType,
            cardList: accountList,
          };
        } else {
          //手动创建
          let cardMsg = storeData.promotion_card_data;
          cardMsg.cardType = this.formData.cardType;
          if (cardMsg.product_selling_points_type === 1) {
            cardMsg.product_selling_points = this.selectedSysList;
          } else {
            cardMsg.product_selling_points = Object.values(this.selectedCusList);
          }
          storeData.promotion_card = cardMsg;
        }
      } else {
        delete storeData.promotion_card;
      }
      delete storeData.promotion_card_data;
      //试玩素材
      if (storeData.playableType === "OFF") {
        storeData.playable_url = null;
      }
      this.$store.commit("set_adCreativeBaseInfo", storeData);
    },
    fillStoreData() {
      if (this.adCreativeBaseInfo) {
        let copyData = JSON.parse(JSON.stringify(this.adCreativeBaseInfo));
        if (copyData.promotion_card) {
          //启用推广卡片
          let cardMsg = copyData.promotion_card;
          copyData.promotion_card = "1";
          this.formData.cardType = cardMsg.cardType;

          if (cardMsg.cardType === 0) {
            //素材选择
            this.$nextTick(() => {
              //切换账号之后重新赋值
              if (this.adCount[0].advertiserId === cardMsg.cardList[0].account.advertiserId) {
                //账号没改变
                this.accountList = cardMsg.cardList;
              } else {
                //账号改变了
                this.accountList = this.adCount.map((account) => {
                  return {
                    account: account,
                    cardData: null,
                  };
                });
              }
            });
            //推广卡片部分赋初始值
            copyData.promotion_card_data = {
              product_image_id: "",
              product_description: "",
              product_selling_points_type: 1, //系统推荐卖点 1， 自定义推广卖点 2
              enable_personal_action: true,
              call_to_action: null,
              path: "",
              component_name: "",
            };
            this.selectedSysList = [];
            this.selectedCusList = { [new Date().getTime()]: "" };
          } else {
            //手动创建

            if (cardMsg.product_selling_points_type === 1) {
              this.selectedSysList = cardMsg.product_selling_points;
            } else {
              let cusList = {};
              cardMsg.product_selling_points.forEach((word) => {
                cusList[Math.random()] = word;
              });
              this.selectedCusList = cusList;
            }
            delete cardMsg.product_selling_points;
            copyData.promotion_card_data = cardMsg;
          }
        } else {
          copyData.promotion_card = "0";
          copyData.promotion_card_data = {
            product_image_id: "",
            product_description: "",
            product_selling_points_type: 1, //系统推荐卖点 1， 自定义推广卖点 2
            enable_personal_action: true,
            call_to_action: null,
            path: "",
            component_name: "",
          };
          this.selectedSysList = [];
          this.selectedCusList = { [new Date().getTime()]: "" };
        }
        this.$set(this, "formData", copyData);
      }
    },
    checkData() {
      return Promise.all([
        //外部表单
        new Promise((resolve, reject) => {
          this.$refs.creativeBasesetRef.validate((valid) => {
            if (valid) {
              resolve();
            } else {
              reject();
            }
          });
        }),
        //推广卡片
        new Promise((resolve, reject) => {
          this.$refs.cardRef.validate((valid) => {
            if (valid) {
              resolve();
            } else {
              reject();
            }
          });
        }),
      ]);
    },
    //推广卡片素材选择
    checkCard(countData) {
      this.$refs.cardModalRef.showModal(countData);
    },
    cardSelectOk(data) {
      let advertiserId = data.advertiserId;
      this.accountList.forEach((item) => {
        if (item.account.advertiserId === advertiserId) {
          item.cardData = data.cardData;
        }
      });
      this.checkRule();
    },
    changePlayableType(val) {
      if (val === "OFF") {
        this.formData.playable_url = null;
      }
    },
    changePromotionCard(val) {
      if (val === "0") {
        this.formData.promotion_card_data.product_image_id = "";
        this.formData.promotion_card_data.product_description = "";
        this.formData.promotion_card_data.product_selling_points_type = 1;
        this.formData.promotion_card_data.enable_personal_action = true;
        this.formData.promotion_card_data.call_to_action = null;
        this.formData.promotion_card_data.path = "";
        this.formData.promotion_card_data.component_name = "";
      }
    },
    checkRule() {
      this.$refs.creativeBasesetRef.validate();
    },
  },
  computed: {
    ...mapState({
      adCount: (state) => state.Promotion.adCount,
      adCreativeBaseInfo: (state) => state.Promotion.draft_ad.adCreativeBaseInfo,
      delivery_placement: (state) => state.Promotion.draft_adset.delivery_placement,
    }),
  },
  watch: {
    //投放范围默认且广告位置为优选广告位、投放范围为通投智选，仅这两种情况下，可设置推广卡片
    delivery_placement(val) {
      if ((val && val.delivery_range === "DEFAULT" && val.inventory_catalog === "SMART") || (val && val.delivery_range === "UNIVERSAL")) {
        this.showCard = true;
      } else {
        this.showCard = false;
        this.formData.promotion_card = "0";
      }

      //广告位置包含抖音时，卡片必填
      if (
        val &&
        val.delivery_range === "DEFAULT" &&
        val.inventory_catalog === "MANUAL" &&
        val.inventory_type.includes("INVENTORY_AWEME_FEED")
      ) {
        this.showCard = true;
        this.onlyCard = true;
        this.formData.promotion_card = "1";
      }
    },
    adCount: {
      handler(val) {
        if (val) {
          let listData = val.map((account) => {
            return {
              account: account,
              cardData: null,
            };
          });
          this.accountList = listData;
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.item-card {
  background-color: #fff;
  padding: 24px;
  margin-bottom: 6px;
  .card-title {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
  }
  .card-content {
    margin-top: 20px;
    .modal-form {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .form-item {
        display: flex;
        margin-bottom: 20px;
        .form-label {
          flex-shrink: 0;
          display: inline-block;
          width: 130px;
          text-align: right;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          // padding-top: 6px;
          &.require::before {
            content: "*";
            display: inline-block;
            color: red;
            margin-right: 4px;
          }
        }
        .form-value {
          width: 100%;
          padding-top: 2px;
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            color: rgba(24, 144, 255, 1);
            border-color: rgba(24, 144, 255, 1);
            background: rgba(24, 144, 255, 1);
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: rgba(0, 0, 0, 0.65);
          }
          .upload-wrap {
            margin-top: 8px;
            border-radius: 2px;
            background: rgba(244, 244, 244, 1);
            padding: 16px;
            .upload-item {
              display: flex;
              margin-bottom: 20px;
              .upload-label {
                font-size: 14px;
                color: rgba(0, 0, 0, 0.65);
                flex-shrink: 0;
                &.require::before {
                  content: "*";
                  display: inline-block;
                  color: red;
                  margin-right: 4px;
                }
              }
              .upload-value {
                /deep/ .el-upload--picture-card {
                  line-height: 20px;
                  width: 104px;
                  height: 104px;
                }
                .add-material {
                  cursor: pointer;
                  width: 104px;
                  height: 104px;
                  border-radius: 2px;
                  border: 1px dashed rgba(0, 0, 0, 0.15);
                  background-color: #fff;
                  display: flex;
                  .add-wrap {
                    display: flex;
                    width: 100%;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    color: rgba(0, 0, 0, 0.65);
                    .add-icon {
                      font-size: 25px;
                      margin-bottom: 10px;
                    }
                    .add-text {
                      font-size: 14px;
                    }
                  }
                  .img-wrap {
                    width: 100%;
                    height: 100%;
                    .materialI-img {
                      width: 100%;
                      height: 100%;
                      object-fit: contain;
                    }
                  }
                }
                .md-wrap {
                  padding-top: 12px;
                  .md-item {
                    .input-item {
                      display: flex;
                      align-items: center;
                      .add-btn {
                        flex-shrink: 0;
                        width: 18px;
                        height: 18px;
                        text-align: center;
                        line-height: 18px;
                        margin-left: 5px;
                        cursor: pointer;
                        color: #fff;
                        border-radius: 2px;
                      }
                    }
                  }
                }
                /deep/.el-form-item__content {
                  line-height: 20px;
                }
              }
            }
          }
          .flow-table-wrap {
            /deep/ th {
              height: 33px;
              padding: 2px 0;
            }
            /deep/ .el-table td,
            .el-table th {
              padding: 2px 0;
            }
            .header-wrap {
              display: flex;
            }
          }
          .material-select {
            .checkTable {
              border-collapse: collapse;
              font-size: 12px;
              border: 1px solid #eee;
              width: 480px;
              .header-tr {
                background-color: #f9fafc;
              }
              .count-wrap {
                width: 200px;
                font-weight: normal;
                .count-id {
                  margin-top: 2px;
                  color: #818181;
                }
              }
              .value-wrap {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .com-name {
                  font-weight: normal;
                }
                .com-btn {
                  color: #0b75ff;
                  font-weight: normal;
                  cursor: pointer;
                  margin-left: 4px;
                  white-space: nowrap;
                }
              }
            }
          }
        }
      }
    }
  }
}
.iframe-wrap {
  height: 450px;
  .iframe-content {
    width: 100%;
    height: 100%;
  }
}
</style>
